import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { CyclesServices } from 'v2/resources/services/cycles';
import {
  ICycle,
  IQueryParamsCycle,
  IResponseCyclesCode,
} from 'v2/resources/types/cycles';
import { useAppDispatch } from '../../useAppSelector';
import { setSelectedCycle } from 'redux/selectedCycle';
import { setCyclesCode } from 'v2/store/cyclesCode/slice';

export const useGetCycles = (
  params: IQueryParamsCycle,
  nameProperty: string
): UseQueryResult<Array<ICycle>> => {
  return useQuery({
    queryKey: ['getCyles', params, nameProperty],
    queryFn: () => CyclesServices.getCycles(params),

    enabled: true,
    refetchOnMount: false,
    refetchOnReconnect: false,
    refetchOnWindowFocus: false,
    staleTime: Infinity,
  });
};
export const useGetCyclesCodes = (
  nameProperty: string
): UseQueryResult<Array<IResponseCyclesCode>> => {
  const dispatch = useAppDispatch();

  return useQuery({
    queryKey: ['getCylesCodes', nameProperty],
    queryFn: () => CyclesServices.getCycleCodes(),

    enabled: true,
    refetchOnMount: false,
    refetchOnReconnect: false,
    refetchOnWindowFocus: false,
    staleTime: Infinity,
    onSuccess: (data) => {
      dispatch(setSelectedCycle(data[data.length - 1]));
      dispatch(setCyclesCode(data.reverse()));
    },
  });
};
